import {
  createContext,
  FC,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

interface Customer {
  customer: string;
  time_of_visit: string;
}

// Update the context interface to include customer
interface DateofVisitType {
  dateOfVisit: string;
  setDateOfVisit: (date: string) => void;
  customerDetails: Customer | null;
  setCustomerDetails: (customer: Customer | null) => void;
}

const DateofVisitContext = createContext<DateofVisitType | undefined>(
  undefined
);
export const DateofVisitProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [dateOfVisit, setDateOfVisit] = useState<string>(() => {
    // Initialize from localStorage if available
    return localStorage.getItem("dateOfVisit") || "";
  });

  const [customerDetails, setCustomerDetails] = useState<Customer | null>(
    () => {
      const stored = localStorage.getItem("customerDetails");
      return stored ? JSON.parse(stored) : null;
    }
  );

  useEffect(() => {
    // Save to localStorage whenever date changes
    if (dateOfVisit) {
      localStorage.setItem("dateOfVisit", dateOfVisit);
    }
  }, [dateOfVisit]);

  useEffect(() => {
    if (customerDetails) {
      localStorage.setItem("customerDetails", JSON.stringify(customerDetails));
    }
  }, [customerDetails]);


  return (
    <DateofVisitContext.Provider
      value={{
        dateOfVisit,
        setDateOfVisit,
        customerDetails,
        setCustomerDetails,
      }}
    >
      {children}
    </DateofVisitContext.Provider>
  );
};

export const useDateOfVisit = () => useContext(DateofVisitContext);
